import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** Inline background colour. When omitted the component uses muted tokens. */
  color?: string;
}

export function Badge({ className, color, style, ...props }: BadgeProps) {
  const mergedStyle = color
    ? { ...style, backgroundColor: color, color: "#fff", borderColor: color }
    : style;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide leading-none",
        color ? "" : "border-border bg-muted text-muted-foreground",
        className,
      )}
      style={mergedStyle}
      {...props}
    />
  );
}
